jQuery(function($){

    // Click on search icon
    $('#search-trigger').on('click', function(){
        if( this.classList.contains('is-open') ){
            return close_search();
        }
        return open_search();
    })

    // Click on cross icon (close search)
    $('#close-search').on('click', close_search );

    // Function that opens the searchform
    function open_search(){
        $('#search-trigger').addClass('is-open');
        $('#searchform').fadeIn();
        window.addEventListener('keydown', handle_keypress_search );
    }

    // Function that closes the searchform
    function close_search(){
        $('#search-trigger').removeClass('is-open');
        $('#searchform').fadeOut();
        window.removeEventListener( 'keydown', handle_keypress_search );
    }

    // Detects if escape key is pressed to close searchform
    function handle_keypress_search(e){
        if( e.key != "Escape" ){
            return;
        }
        return close_search();
    }

});